import React from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../../components/Common/withRouter";
import { useSelector } from "react-redux";
import { DF_CO0005Context } from "./context";

function DF_CO0005(props) {
  document.title = "Defender | Anulação Validação Documento";

  const { isModalPage } = useSelector((state) => ({
    isModalPage: state.Layout.isModalPage,
  }));

  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  if (!parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parametros
      </Alert>
    );
  }

  return (
    <DF_CO0005Context.Provider
      value={{
        parseParams,
      }}
    >
      <div
        className="page-content"
        {...(isModalPage && { style: { padding: "0px", overflow: "hidden" } })}
      >
        <Container fluid={true}>
          <GridHeader />
          <GridBody />
        </Container>
      </div>
    </DF_CO0005Context.Provider>
  );
}

export default withRouter(DF_CO0005);